const icon = require('vue-svgicon');
icon.register({
    'upload-file-done': {
        width: 14,
        height: 18,
        viewBox: '0 0 14 18',
        data: `<path pid="0" d="M7,11.8L4.4,9.2L3.7,9.9L7,13.2l3.3-3.3L9.6,9.2 M1.6,18c-0.5,0-0.8-0.2-1.2-0.5S0,16.8,0,16.4V1.6 c0-0.5,0.2-0.8,0.5-1.2S1.2,0,1.6,0h7.9L14,4.5v11.9c0,0.5-0.2,0.8-0.5,1.2S12.8,18,12.4,18H1.6z M9,5V1H1.6C1.5,1,1.3,1.1,1.2,1.2 S1,1.5,1,1.6v14.8c0,0.2,0.1,0.3,0.2,0.4C1.3,16.9,1.5,17,1.6,17h10.8c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.3,0.2-0.4V5H9z" _fill="#000"/>`,
    },
});
